let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9Y5Xm")).then(() => parcelRequire('h49zj'));